import APIRequest from "./APIRequest";

/**
 * Fetch available subscription packages
 * Route: GET /list-packaging
 */
export const getPackages = (params = {}) => {
  return APIRequest.get("list-packaging", params);
};

/**
 * Activate/purchase a subscription package
 * Route: POST /subscribe
 * Body: { package_id, payment_intent, ... }
 */
export const subscribe = (params) => {
  return APIRequest.post("subscribe", params);
};

const subscriptionService = {
  getPackages,
  subscribe,
};

export default subscriptionService;
